<full-modal-config
    modalTitle="{{ (isEditing ? l10nKeys.modalTitleEdit : l10nKeys.modalTitleNew) | vtranslate : editable.config.name  || ''}}"
    [modified]="form.touched && form.dirty"
    (onCancel)="handleCancel()"
    (onSubmit)="handleSubmit()"
    [errors]="editable.errors"
    [valid]="form.valid"
    class="network-security-rule-modal"
>
    <form
        clrForm
        [clrLayout]="verticalLayout"
        #form="ngForm"
    >
        <full-modal-tab-section
            tabTitle="{{ l10nKeys.sectionTitleGeneral | vtranslate }}"
            class="full-modal-config__grid-container-full"
        >
                <h3>{{ l10nKeys.sectionTitleGeneral | vtranslate }}</h3>
                <div>
                    <clr-checkbox-container>
                        <clr-checkbox-wrapper>
                            <input
                                clrCheckbox
                                id="enable-checkbox"
                                type="checkbox"
                                name="enable-checkbox"
                                [(ngModel)]="editable.config.enable"
                            />
                            <label
                                for="enable-checkbox"
                                fieldName="enable"
                                objectType="{{ objectType }}"
                                required
                            >
                                {{ l10nKeys.enableRuleLabel | vtranslate }}
                            </label>
                        </clr-checkbox-wrapper>
                    </clr-checkbox-container>
                </div>
                <div>
                    <avi-input-container noMarginTop>
                        <label
                            aviLabelWithTooltip
                            fieldName="name"
                            for="name"
                            objectType="{{ objectType }}"
                            required
                        >
                            {{ l10nKeys.nameInputLabel | vtranslate }}
                        </label>
                        <input
                            id="name"
                            name="name"
                            [(ngModel)]="editable.config.name"
                            clrInput
                            placeholder="{{ l10nKeys.nameInputPlaceholder | vtranslate }}"
                            regexPattern="objName"
                            required
                        />
                    </avi-input-container>
                </div>
                <div>
                    <clr-checkbox-container>
                        <clr-checkbox-wrapper>
                            <input
                                clrCheckbox
                                id="logging-checkbox"
                                type="checkbox"
                                name="logging-checkbox"
                                [(ngModel)]="editable.config.log"
                            />
                            <label
                                for="logging-checkbox"
                                fieldName="log"
                                objectType="{{ objectType }}"
                                required
                            >
                                {{ l10nKeys.enableLoggingLabel | vtranslate }}
                            </label>
                        </clr-checkbox-wrapper>
                    </clr-checkbox-container>
                </div>
        </full-modal-tab-section>
        <full-modal-tab-section
            class="full-modal-config__grid-container-full"
            tabTitle="{{ l10nKeys.sectionTitleMatch | vtranslate }}"
        >
            <h3>{{ l10nKeys.sectionTitleMatch | vtranslate }}</h3>
            <avi-alert-group 
                alertType="info"
                *ngIf="!editable.config.match.hasAnyEntry()"
            >
                <span>{{ globalL10nKeys.matchRequiredInfo | vtranslate }}</span>
            </avi-alert-group>
            <div>
                <match-adder
                    [invalidateForm]="!editable.config.match.hasAnyEntry()"
                    [match]="editable.config.match"
                    [matchOptions]="matchOptions"
                ></match-adder>
            </div>
        </full-modal-tab-section>
        <full-modal-tab-section
            class="full-modal-config__grid-container-full"
            tabTitle="{{ l10nKeys.sectionTitleAction | vtranslate }}"
        >
            <h3>{{ l10nKeys.sectionTitleAction | vtranslate }}</h3>
            <avi-fieldset 
                [hideContent]="editable.config.action !== 
                    networkSecurityPolicyActionType.NETWORK_SECURITY_POLICY_ACTION_TYPE_RATE_LIMIT"
            >
                <avi-fieldset_header>
                    <label
                        aviLabelWithTooltip
                        for="network-security-rule-action"
                    >
                        {{ l10nKeys.networkSecurityRuleActionLabel | vtranslate }}
                    </label>
                    <clr-radio-container clrInline>
                        <clr-radio-wrapper>
                            <input
                                type="radio"
                                name="allow"
                                [(ngModel)]="editable.config.action"
                                (ngModelChange)="editable.handleActionChange()"
                                [value]="networkSecurityPolicyActionType.NETWORK_SECURITY_POLICY_ACTION_TYPE_ALLOW"
                                clrRadio
                            />
                            <label>{{ l10nKeys.allowLabel | vtranslate }}</label>
                        </clr-radio-wrapper>
                        <clr-radio-wrapper>
                            <input
                                type="radio"
                                name="deny"
                                [(ngModel)]="editable.config.action"
                                (ngModelChange)="editable.handleActionChange()"
                                [value]="networkSecurityPolicyActionType.NETWORK_SECURITY_POLICY_ACTION_TYPE_DENY"
                                clrRadio
                            />
                            <label>{{ l10nKeys.denyLabel | vtranslate }}</label>
                        </clr-radio-wrapper>
                        <clr-radio-wrapper>
                            <input
                                type="radio"
                                name="rate-limit"
                                [(ngModel)]="editable.config.action"
                                (ngModelChange)="editable.handleActionChange()"
                                [value]="networkSecurityPolicyActionType.NETWORK_SECURITY_POLICY_ACTION_TYPE_RATE_LIMIT"
                                clrRadio
                            />
                            <label>{{ l10nKeys.rateLimitLabel | vtranslate }}</label>
                        </clr-radio-wrapper>
                    </clr-radio-container>
                </avi-fieldset_header>
                <avi-fieldset_content>
                    <div
                        class="full-modal-config__form-control-row rate-limit-action__no-margin-top"
                        *ngIf="editable.config.action === networkSecurityPolicyActionType.NETWORK_SECURITY_POLICY_ACTION_TYPE_RATE_LIMIT"
                    >
                        <div class="full-modal-config__form-control">
                            <avi-input-container noMarginTop>
                                <label
                                    aviLabelWithTooltip
                                    fieldName="burst_size"
                                    for="burst-size"
                                    objectType="{{ objectRulesType.networkSecurityPolicyActionRLParam }}"
                                    required
                                >
                                    {{ l10nKeys.connectionBurstSizeLabel | vtranslate }}
                                </label>
                                <input
                                    id="burst-size"
                                    name="burst_size"
                                    fieldName="burst_size"
                                    type="number"
                                    [(ngModel)]="editable.rateLimitParam.burst_size"
                                    clrInput
                                    placeholder="{{ l10nKeys.connectionBurstSizePlaceholder | vtranslate }}"
                                    objectType="{{ objectRulesType.networkSecurityPolicyActionRLParam }}"
                                    required
                                    configFieldInputValidation
                                />
                            </avi-input-container>
                        </div>
                        <div class="full-modal-config__form-control">
                            <avi-input-container noMarginTop>
                                <label
                                    aviLabelWithTooltip
                                    fieldName="max_rate"
                                    for="max-rate"
                                    objectType="{{ objectRulesType.networkSecurityPolicyActionRLParam }}"
                                    required
                                >
                                    {{ l10nKeys.maxRateLabel | vtranslate }}
                                </label>
                                <input
                                    id="max-rate"
                                    name="max_rate"
                                    fieldName="max_rate"
                                    type="number"
                                    [(ngModel)]="editable.rateLimitParam.max_rate"
                                    clrInput
                                    placeholder="{{ l10nKeys.maxRatePlaceholder | vtranslate }}"
                                    objectType="{{ objectRulesType.networkSecurityPolicyActionRLParam }}"
                                    required
                                    configFieldInputValidation
                                />
                            </avi-input-container>
                        </div>
                    </div>
                </avi-fieldset_content>
            </avi-fieldset>
        </full-modal-tab-section>
    </form>
</full-modal-config>
